import {Page} from '../src/common/constant/page';
import {ZIndex} from '../src/common/scss/util/variable';
import {IKwPage} from '../src/common/type';
import SearchV4 from '../src/search/container/SearchV4';
import {ISearchType} from '../src/search/type';

interface IProps {
  keyword: string;
  type: ISearchType;
}

interface IQuery {
  keyword?: string;
  type?: string;
}

const SearchPage: IKwPage<IProps, IQuery> = ({keyword, type}) => {
  return <SearchV4 initialKeyword={keyword} type={type} />;
};

SearchPage.getInitialProps = ({query}) => {
  return {
    keyword: query.keyword || '',
    type: query.type as ISearchType,
  };
};

SearchPage.initialPageProps = {
  page: Page.Search,
  getPageTitle: i18next => i18next.t('search_title'),
  pageBgClassName: 'bg-transparent',
  zIndex: ZIndex.Modal + 1,
};

export default SearchPage;
